import { Workout } from '@/types/workout';

/**
 * Preset workouts available for unauthenticated users.
 * These serve as examples and can be used without login.
 */
export const presetWorkouts: Workout[] = [
  {
    id: 'preset-quick-mobility',
    name: 'Quick Mobility',
    description: 'A 5-minute mobility routine to start your day',
    duration_minutes: 5,
    exercises: [],
    created_at: new Date().toISOString(),
    is_preset: true,
    focus: 'mobility',
    intensity: 'gentle',
  },
  {
    id: 'preset-core-express',
    name: 'Core Express',
    description: 'A quick 10-minute core workout',
    duration_minutes: 10,
    exercises: [],
    created_at: new Date().toISOString(),
    is_preset: true,
    focus: 'core',
    intensity: 'moderate',
  },
];
